module.exports = __webpack_public_path__ + "static/DC2-5beaf12c43e7630193f0e4a3813fe50e.jpg";